import styled from 'styled-components';

export const CollapseWrapper = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const ToggleButton = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    ${(props) => props.theme.selectableElement(false)}
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
`;

export const TextWrapper = styled.p`
    text-align: center;
    margin-bottom: 0;
`;

type ContentWrapperProps = {
    isOpen: boolean;
};

export const ContentWrapper = styled.div<ContentWrapperProps>`
    display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;
